import { mapState, mapMutations } from 'vuex'

import maInput from '@/components/input'
import maTooltip from '@/components/tooltip'
import maNumberSelector from '@/components/numberSelector'

// types
import { WARRANTY_MODULE_NAME, WARRANTY_UPDATE_LAST_PIECE_SELECTED } from '@/store/types'

/**
 * @module
 * @name InputBtnIcon
 * @extends Input
  */
export default {
  name: 'InputBtnIcon',
  extends: maInput,

  data: function () {
    return {
      minPieceId: 1
    }
  },
  /**
   * @property {Array} options Array of options. Option contain key and value.
   * @property {String} icon VueSVGIcon icon.
   */
  props: {
    options: {
      type: Array,
      required: false,
      default: []
    },
    icon: {
      type: String,
      required: false
    },
    showTooltipBtn: {
      type: Boolean,
      required: false
    },
    textTooltipBtn: {
      type: String,
      required: false
    },
    showNumberSelector: {
      type: Boolean,
      required: false,
      default: false
    },
    buttonContentClass: {
      type: String,
      required: false,
      default: undefined
    },
    showCancel: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    maTooltip,
    maNumberSelector
  },
  computed: {
    ...mapState({
      pieceSelected: state => state.warranty.lastPieceSelected
    })
  },
  methods: {
    ...mapMutations(WARRANTY_MODULE_NAME, {
      updateLastPieceSelected: WARRANTY_UPDATE_LAST_PIECE_SELECTED
    }),
    /**
     * @function
     * @name isChecked
     * @description On component rendering toggles class if it's selected.
     * @param {String} inputKey Option key.
     * @returns {Boolean}
     */
    isChecked: function (inputKey) {
      return this.type === 'checkbox' ? this.value[inputKey] === true : this.value === inputKey
    },
    /**
     * @function
     * @name handleClick
     * @param {String} inputKey Option key
     * @description Handler for click. If inputBtn is used as checkbox, all the
     *              values are reviewed for setting each of them checked. If not,
     *              it can be used as radio button. Then, value / values are
     *              emitted.
     */
    handleClick: function (option) {
      if (option == null) {
        this.setPieceSelected(null)
        this.$emit('change', null)
      } else if (this.type === 'checkbox') {
        this.emitSelectedCheckbox()
      } else {
        this.$emit('change', option.key)
      }

      if (option?.piece_id) {
        this.setPieceSelected(this.createPieceObject(option.key, option.piece_id))
      }
    },

    emitSelectedCheckbox: function() {
      let selectedInput = this.$el.querySelectorAll('input[type="checkbox"]')
      const selectedValues = {}
      selectedInput.forEach(input => {
        selectedValues[input.value] = input.checked
      })
      this.$emit('change', selectedValues)
    },

    emitPieceInfo: function(piece) {
      this.$emit('piece', piece)
    },

    onPieceNumberSelected: function(value, option) {
      this.setPieceSelected(this.createPieceObject(option.key, value))
    },

    setPieceSelected: function(newPiece) {
      this.updateLastPieceSelected(newPiece)
      this.emitPieceInfo(newPiece)
    },

    createPieceObject(name, pieceId) {
      return { name, piece_id: pieceId }
    }
  }
}
